<template>
  <div
    class="custom-message-component-positioned"
    :style="{...style}"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import { CustomMessagePositionedComponent } from '_c/typings/model/chat/text-node';
import { pushUrl, getWidth } from '@/business/chat/custom-message-util';
import { defineComponent, PropType, toRaw } from 'vue';


export default defineComponent({
  name: 'CustomMessagePositioned',
  props: {
    attr: {
      type: Object as PropType<CustomMessagePositionedComponent>,
      required: true,
    },
  },
  setup(props) {
    let scale = 1;
    const attr = toRaw(props.attr);
    if (attr.scale) {
      scale = toRaw(attr.scale);
    }
    const width = getWidth(props.attr.width, scale);
    const style = {
      width,
      height: attr.height ? `${attr.height * scale}px` : '',
      top: attr.top ? `${attr.top}px` : '',
      left: attr.left ? `${attr.left}px` : '',
      right: attr.right ? `${attr.right}px` : '',
      bottom: attr.bottom ? `${attr.bottom}px` : '',
    };

    function clickHandle(e: Event): void {
      if (attr.onClick) {
        e.stopPropagation();
        pushUrl(attr.onClick, attr.reportData);
      }
    }
    return {
      style,
      clickHandle,
    };
  },
});

</script>

<style scoped>
.custom-message-component-positioned {
  position: absolute;
}
</style>
